import React, { useState } from "react";
import PropTypes from "prop-types";
import useDebounce from "../../../../../hook/useDebounce";
import { ArrowDownIcon } from "../../../../../components/Icons/ArrowDownIcon";
import { useEffect } from "react";
import { useApp } from "../../../../../contexts";

function Price(props) {
  const { title, onChange, isLastest } = props;
  const [show, $show] = useState(true);
  const [priceFrom, $priceFrom] = useState(null);
  const [priceTo, $priceTo] = useState(null);
  const [isSearch, $isSearch] = useState(false);
  const debounePriceFrom = useDebounce(priceFrom, 500);
  const debounePriceTo = useDebounce(priceTo, 500);

  useEffect(() => {
    if (!isSearch) return;
    onChange({
      priceFrom: debounePriceFrom,
      priceTo: debounePriceTo,
    });
  }, [debounePriceFrom, debounePriceTo]);
  const { T } = useApp();
  return (
    <div
      className={
        "pt-[10px] pb-3 lg:pt-[32px] lg:pb-7 px-0" +
        (isLastest ? "" : " border-b border-solid border-black/[.15]")
      }
    >
      <div
        className="flex items-center justify-between text-base lg:text-lg font-bold text-black cursor-pointer"
        onClick={() => $show(!show)}
      >
        <span>{title}</span>
        {show && <ArrowDownIcon className="rotate-180 w-[12px] h-[12px]" />}
        {!show && <ArrowDownIcon className="w-[12px] h-[12px]" />}
      </div>
      <div
        className={
          "flex items-center justify-start filter-price-left flex-nowrap gap-[14px] mt-[20px] lg:mt-[30px]" +
          (show ? "" : " hidden")
        }
      >
        <input
          type="number"
          min={0}
          onChange={(e) => {
            $isSearch(true);
            $priceFrom(e.target.value);
          }}
          placeholder={T("From")}
        ></input>
        <input
          type="number"
          min={1}
          onChange={(e) => {
            $isSearch(true);
            $priceTo(e.target.value);
          }}
          placeholder={T("To")}
        ></input>
      </div>
    </div>
  );
}

Price.propTypes = {
  title: PropTypes.string,
  options: PropTypes.array,
  name: PropTypes.string,
  value: PropTypes.array,
  onChange: PropTypes.func,
  isLastest: PropTypes.bool,
};

export default Price;
